import { render, staticRenderFns } from "./NotificationBarError.vue?vue&type=template&id=4b3373c4&scoped=true"
import script from "./NotificationBarError.vue?vue&type=script&lang=js"
export * from "./NotificationBarError.vue?vue&type=script&lang=js"
import style0 from "./NotificationBarError.vue?vue&type=style&index=0&id=4b3373c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3373c4",
  null
  
)

export default component.exports